import React, { Component } from "react";
import PropTypes from "prop-types";
import queryString from "query-string";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";

import Str from "shared/components/Str";

import Package from "./Package";

import "./IncognitoPackages.scss";

export default class IncognitoPackages extends Component {
	static propTypes = {
		isMobile: PropTypes.bool.isRequired,
		isLoading: PropTypes.bool.isRequired,
		fetchProductPackages: PropTypes.func.isRequired,
		openPayment: PropTypes.func.isRequired,
		openPaymentMobile: PropTypes.func.isRequired,
		loadPage: PropTypes.func.isRequired,

		productPackages: PropTypes.array.isRequired,
	};

	componentWillMount() {
		this.props.loadPage();

		let isPremium = false;

		if (window.location && window.location.search) {
			const qs = queryString.parse(window.location.search);

			if (qs.premium) {
				isPremium = true;
			}
		}

		this.props.fetchProductPackages(isPremium);
	}

	render() {
		const {
			openPayment,
			openPaymentMobile,
			productPackages,
			isLoading,
			isMobile,
		} = this.props;

		const topPrice = productPackages.reduce((memo, { initialUnitPrice }) => {
			return initialUnitPrice > memo ? initialUnitPrice : memo;
		}, 0);

		return (
			<CSSTransitionGroup
				transitionName="incognitopackages-transition"
				transitionAppear={false}
				transitionEnter={true}
				transitionEnterTimeout={300}
				transitionLeave={false}
			>
				{!isLoading &&
					<div className="incognitopackages-packages oknf oknf--gray">
						{productPackages.map((pkg, i) => (
							<Package
								{...pkg}
								key={pkg.productid}
								mostPopular={i === 0}
								topPrice={topPrice}
								onClick={(productid) => {
									if (isMobile) {
										openPaymentMobile(productid);
									} else {
										openPayment(productid);
									}
								}}
							/>
						))}

						<div className="incognitopackages-disclaimer">
							<Str>You can downgrade or cancel this subscription at any time!</Str>
						</div>
					</div>
				}
			</CSSTransitionGroup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/apps/incognito_packages/components/IncognitoPackages.jsx